import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {AlertService} from '../../../../services/alert/alert.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent implements OnInit {
  title: string;
  message: string;
  falsyText: string;
  truthyText: string;

  constructor(public bsModalRef: BsModalRef,private alert:AlertService) { }

  ngOnInit() {
  }

  emitValue(value) {
    this.alert.emmitConfirmationValue(value);
    this.bsModalRef.hide();
  }
}
